"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPagination = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Pagination_1 = require("./Pagination");
const ListPagination = ({ pagination, onPageChange, isLoading, className }) => pagination && pagination.totalPages > 1 ? ((0, jsx_runtime_1.jsx)(Pagination_1.Pagination, { currentPage: pagination.currentPage, totalPages: pagination.totalPages, totalItems: pagination.totalItems, pageSize: pagination.pageSize, onPageChange: onPageChange, isLoading: isLoading, className: className })) : null;
exports.ListPagination = ListPagination;
exports.ListPagination.displayName = 'ListPagination';
